// extracted by mini-css-extract-plugin
export default {"img1":"style_img1__mJD42","img2":"style_img2__vzqRj","img3":"style_img3__ZXaQ8"};